/* Jibbitz Cross Selling Swiper */

document.addEventListener('DOMContentLoaded', ()=> {

    const params = new URLSearchParams(window.location.search);
    // const locationFilter = params.get('storeSelected'); 
    const locationFilter = JSON.parse(localStorage.getItem('locationUserSettings'))?.store;

    const cssContainer = document.getElementById('css-container');
    const sliderContainer = document.getElementById('css-slider-swipper');
    const allSlides = sliderContainer ? sliderContainer.querySelectorAll('[data-variant-available-locations]') : [];

    if (locationFilter) { 
        allSlides.forEach((el) => {      
            console.log("→", el.dataset);
               
            if (!el.dataset.variantAvailableLocations.includes(locationFilter) || el.dataset.variantAvailableLocations == null) {
                 el.closest('.css-swiper-slide')?.remove();
            }
        });
    } 

    const availableSlides = sliderContainer ? sliderContainer.querySelectorAll('[data-variant-available-locations]').length : 0;
    const swiperSelector = '.css-slider-swipper';
    const swiperElement = document.querySelector(swiperSelector);

    if (swiperElement && availableSlides > 0) {
        
        const maxSlidesView = Math.min(6, availableSlides); 
        
        const jbzSwiper = new Swiper(swiperSelector, {
            init:false,
            direction: 'horizontal',
            slidesPerView: 2, 
            spaceBetween: 8,
            speed: 800,            
            loop: false, 
            
            // autoplay: availableSlides > 1 ? {
            //     delay: 5000
            // } : false, 
            
            // If we need pagination
            // pagination: {
            //     el: '.css-swiper-pagination',
            //     clickable: true,
            // },
            // Navigation arrows
            navigation: {
                nextEl: '.css-swiper-button-next',
                prevEl: '.css-swiper-button-prev',
            },
            breakpoints: {
                991: {
                    slidesPerView: 2, 
                    spaceBetween: 8,
                },
                1024: {
                  slidesPerGroup: maxSlidesView,
                  slidesPerView: maxSlidesView,
                  spaceBetween: 8,
                },
            },
            on: {
              init: () => {
                if (cssContainer) cssContainer.style.display = 'flex';                
              }
            },
        });

        jbzSwiper.init();

    } else if (availableSlides === 0) {
        console.log('No hay slides disponibles para mostrar');
        if (cssContainer) {
            cssContainer.style.display = 'none';
        }
    } else {
        console.log('El contenedor principal del Swiper no existe en el DOM');
    }

    const jbz_container = document.getElementById('css-container');
    const jbz_close_btn = document.getElementById('css-header-close');

    if(jbz_close_btn && jbz_container){
        jbz_close_btn.addEventListener('click', () => {
            console.log('Click en cerrar cross');
            jbz_container.style.display = 'none';
        });
    }  

});